module.exports = __webpack_public_path__ + "static/media/loc1_img34.7f19b81a.jpg";